// Shared chart style constants — extracted to avoid creating new objects on every render
export const CHART_TOOLTIP_STYLE = {
  background: "#fff",
  border: "1px solid #e4e4e7",
  borderRadius: 8,
};

export const CHART_GRID_STROKE = "#f4f4f5";
export const AXIS_COLOR = "#71717a";
export const PAIN_DOMAIN = [0, 10];
export const PIE_COLORS = ["#d4af37", "#09090b", "#52525b", "#a1a1aa", "#e4e4e7"];

export function dashboardPathFor(user) {
  if (!user) return "/login";
  if (user.role === "admin") return "/admin";
  if (user.role === "clinic_manager") return "/app/clinic";
  return "/app/dashboard";
}
